import React, { useState } from "react";
import { CartesianCoordinateHotelConfig } from "../../../../Model/Calibration";
import TabPanel from "../../../PlateTypeEditor/TabPanel";
import PsrCameraManualControl, { PSR_CAMERA_MANUAL_ACCORDION_STATE } from "../../Control/PsrCameraManualControl";
import AutoCalibrationCommandPanel, { AUTO_CAL_ACCORDION_STATE } from "./AutoCalibration/AutoCalibrationCommandPanel";

function getChevronButtonDegree(key: string): number {
  const value = localStorage.getItem(key);
  if (value != null) {
    const objVal = JSON.parse(value) as boolean[];
    if (objVal.every((val) => val)) {
      return 180;
    }
    return 0;
  } else {
    return 0;
  }
}

function setAllTabAccordionExpandState(key: string, state: boolean) {
  let states: boolean[] = [];
  let stateLength = 0; // how many accordion in the page
  switch (key) {
    case AUTO_CAL_ACCORDION_STATE:
      stateLength = 2;
      break;
    case PSR_CAMERA_MANUAL_ACCORDION_STATE:
      stateLength = 3;
      break;
    default:
      stateLength = 0;
      break;
  }
  for (let index = 0; index < stateLength; index++) {
    states.push(state);
  }

  if (states.length > 0) {
    localStorage.setItem(key, JSON.stringify(states));
  }
}

type Props = {
  setOnApply: (onApply: { execute: () => void; disabled: boolean }) => void;
  setOnCancel: (onCancel: { execute: () => void; disabled: boolean }) => void;
  isCalibrationUpdated: boolean;
  setIsCalibrationUpdated: (isCalibrationUpdated: boolean) => void;
  psrCameraId: number;
  psrIdentifier: string;
};

export default function StorageCalibrationCommandPanel({
  setOnApply,
  setOnCancel,
  isCalibrationUpdated,
  setIsCalibrationUpdated,
  psrCameraId,
  psrIdentifier,
}: Props) {
  const [triggerExpandSetting, setTriggerExpandSetting] = useState(false);
  const [chevronButtonDegree, setChevronButtonDegree] = useState(
    getChevronButtonDegree(AUTO_CAL_ACCORDION_STATE)
  );

  //auto calibration results value to send to backend
  const [updatedCoordinateHotelConfigs, setUpdatedCoordinateHotelConfigs] =
    useState([] as CartesianCoordinateHotelConfig[]);

  const onAllChildrenCollapsed = (collapsed: boolean) => {
    if (collapsed) {
      setChevronButtonDegree(0);
    } else {
      setChevronButtonDegree(180);
    }
  };

  const onClickTab = (header: string) => {
    switch (header) {
      case "Storage Calibration":
        setChevronButtonDegree(
          getChevronButtonDegree(AUTO_CAL_ACCORDION_STATE)
        );
        break;
      case "Control Panel":
        setChevronButtonDegree(
          getChevronButtonDegree(PSR_CAMERA_MANUAL_ACCORDION_STATE)
        );
        break;
    }
  };

  const onTriggerExpandAll = () => {
    if (chevronButtonDegree === 0) {
      setAllTabAccordionExpandState(AUTO_CAL_ACCORDION_STATE, true);
      setAllTabAccordionExpandState(PSR_CAMERA_MANUAL_ACCORDION_STATE, true);
    } else {
      setAllTabAccordionExpandState(AUTO_CAL_ACCORDION_STATE, false);
      setAllTabAccordionExpandState(PSR_CAMERA_MANUAL_ACCORDION_STATE, false);
    }
    setTriggerExpandSetting(true);
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        height: "100%",
        overflow: "auto",
        fontSize: 14,
        WebkitBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        MozBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <TabPanel
        id="storage-cal-command-tab"
        collapsible={false}
        activeTabStyle={{ padding: 0 }}
        chevronButton="double"
        onTriggerExpand={onTriggerExpandAll}
        chevronButtondegree={chevronButtonDegree}
        onClickTab={onClickTab}
      >
        {{
          "Storage Calibration": (
            <AutoCalibrationCommandPanel
              isCalibrationUpdated={isCalibrationUpdated}
              psrIdentifier={psrIdentifier}
              setIsCalibrationUpdated={setIsCalibrationUpdated}
              setOnApply={setOnApply}
              setOnCancel={setOnCancel}
              triggerExpandAll={triggerExpandSetting}
              setTriggerExpandAll={setTriggerExpandSetting}
              onAllItemCollapsed={onAllChildrenCollapsed}
            />
          ),
          "Control Panel": (
            <PsrCameraManualControl
              disabled={false}
              psrCameraId={psrCameraId}
              psrIdentifier={psrIdentifier}
              headerEnabled={false}
              triggerExpandAll={triggerExpandSetting}
              setTriggerExpandAll={setTriggerExpandSetting}
              onAllItemCollapsed={onAllChildrenCollapsed}
            />
          ),
        }}
      </TabPanel>
    </div>
  );
}
